import { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useParams } from "react-router-dom";
import { InputMask } from "@react-input/mask";

import "./style.css";
import { DasboardContext } from "../../context/dashboard-context";

const DeviceDetailScreen = () => {
	const { usernames } = useContext(DasboardContext);
	const [deviceDetail, setDeviceDetail] = useState([]);
	const [loading, setLoading] = useState(true);
	const [updating, setUpdating] = useState(false);
	const [error, setError] = useState("");
	const [success, setSuccess] = useState("");

	const [deviceID, setDeviceID] = useState("");
	const [organization, setOrganization] = useState("");
	const [person, setPerson] = useState("");
	const [status, setStatus] = useState("");
	const [brand, setBrand] = useState("");
	const [purchaseDate, setPurchaseDate] = useState("");
	const [installationDate, setInstallationDate] = useState("");
	const [location, setLocation] = useState("");
	const [room, setRoom] = useState("");
	const [floor, setFloor] = useState("");
	const [roomType, setRoomType] = useState("");
	const [roomName, setRoomName] = useState("");
	const [smsPhone, setSmsPhone] = useState([""]);
	const [suiteName, setSuiteName] = useState("");
	const [deviceNote, setDeviceNote] = useState("");
	const [username, setUsername] = useState("");
	const [isDemo, setIsDemo] = useState(false);
	const [basement, setBasement] = useState();
	const [sosNumber, setSosNumber] = useState(["", "", "", ""]);
	const [updatingSos, setUpdatingSos] = useState(false);
	const [fallSensitivity, setFallSensitivity] = useState(3);
	const [updatingFallSensitivity, setUpdatingFallSensitivity] = useState(false);

	const [orgName, setOrgName] = useState();

	//For room count and floor count
	const [org, setOrg] = useState();
	const [floorCount, setFloorCount] = useState(0);
	const [roomCount, setRoomCount] = useState(0);

	const locations = ["Kurum", "Ev", "Depo", "Bakım"];
	const deviceStatus = ["Aktif", "Pasif", "Teknik Arıza"];
	const roomTypeSelect = [
		"Banyo",
		"Yatak Odası",
		"Aile Odası",
		"Koridor",
		"Mutfak",
		"Yemek Odası",
		"Oturma Odası",
		"Diğer",
	];

	const addPhoneNumber = () => {
		if (smsPhone.length < 6) {
			setSmsPhone([...smsPhone, ""]);
		}
	};

	const removePhoneNumber = (index) => {
		setSmsPhone(smsPhone.filter((_, i) => i !== index));
	};

	const handlePhoneNumberChange = (index, value) => {
		const newPhoneNumbers = [...smsPhone];
		newPhoneNumbers[index] = value;
		setSmsPhone(newPhoneNumbers);
	};

	const { id } = useParams();

	const getOrganisations = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/organisations`);
			const organisationName = await response.json();
			setOrgName(organisationName);
			console.log(organisationName);
		} catch (error) {
			console.error("Veri getirilirken bir hata oluştu:", error);
		}
	};

	async function updateDevice() {
		setError("");
		setSuccess("");

		// Validasyonlar
		if (!deviceID?.trim()) {
			setError("Cihaz ID boş bırakılamaz.");
			return;
		}

		if (!organization?.trim()) {
			setError("Kurum adı seçilmelidir.");
			return;
		}

		if (!brand?.trim()) {
			setError("Cihaz markası boş bırakılamaz.");
			return;
		}

		try {
			setUpdating(true);
			const response = await fetch("https://app.vivasmartcare.com/api/device-update", {
				method: "PUT",
				body: JSON.stringify({
					id,
					deviceID,
					organization,
					person,
					status,
					brand,
					purchaseDate,
					installationDate,
					location,
					floor,
					room,
					roomName,
					smsPhone,
					suiteName,
					deviceNote,
					roomType,
					isDemo: isDemo ? "true" : "false", // Backend String bekliyor
					sosNumber,
					fallSensitivity,
				}),
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				setSuccess("Cihaz bilgileri başarıyla güncellendi.");
				setTimeout(() => {
					fetchData();
				}, 1000);
			} else {
				const data = await response.json();
				setError(data.message || "Cihaz güncellenirken bir hata oluştu");
			}
		} catch (error) {
			console.error("Güncelleme işlemi sırasında bir hata oluştu:", error);
			setError("Bağlantı hatası. Lütfen tekrar deneyin.");
		} finally {
			setUpdating(false);
		}
	}

	const fetchData = async () => {
		try {
			setLoading(true);
			setError("");
			const response = await fetch(`https://app.vivasmartcare.com/api/devices/${id}`);
			if (response.ok) {
				const devices = await response.json();
				setDeviceDetail(devices);
				setDeviceID(devices.deviceID);
				setOrganization(devices.organization);
				setPerson(devices.person);
				setStatus(devices.status);
				setBrand(devices.brand);
				setPurchaseDate(devices.purchaseDate);
				setInstallationDate(devices.installationDate);
				setLocation(devices.location);
				setUsername(devices.person);
				setFloor(devices.floor);
				setRoom(devices.room);
				setRoomName(devices.roomName);
				setSmsPhone(devices.smsPhone || [""]);
				setSuiteName(devices.suiteName);
				setDeviceNote(devices.deviceNote);
				setRoomType(devices.roomType);
				// isDemo boolean'a çevir - backend String olarak saklıyor olabilir
				setIsDemo(
					devices.isDemo === true ||
					devices.isDemo === "true" ||
					devices.isDemo === 1 ||
					devices.isDemo === "1" ||
					devices.isDemo === "True"
				);
				if (devices.sosNumber) {
					const sosArr = Array.isArray(devices.sosNumber) ? [...devices.sosNumber] : [devices.sosNumber];
					while (sosArr.length < 4) sosArr.push("");
					setSosNumber(sosArr.slice(0, 4));
				} else {
					setSosNumber(["", "", "", ""]);
				}
				setFallSensitivity(devices.fallSensitivity || 3);
			} else {
				setError("Cihaz bilgileri yüklenirken bir hata oluştu.");
			}
		} catch (error) {
			console.error("Error fetching device data:", error);
			setError("Bağlantı hatası. Lütfen tekrar deneyin.");
		} finally {
			setLoading(false);
		}
	};

	async function deleteDevice() {
		try {
			const response = await fetch("https://app.vivasmartcare.com/api/device", {
				method: "DELETE",
				body: JSON.stringify({
					id,
				}),
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				alert("Cihaz Silindi");
				window.location.href = "/devices";
			} else {
				alert("Cihaz silinirken bir hata oluştu");
			}
		} catch (error) {
			console.error("Silme işlemi sırasında bir hata oluştu:", error);
		}
	}

	useEffect(() => {
		getOrganisations();
	}, []);

	useEffect(() => {
		fetchData();
		// Cihaz V04T ise açılışta otomatik hassasiyet sorgusu gönder
		if (id && (brand === "V04T" || brand === "Vivistar")) {
			const querySensitivity = async () => {
				try {
					await fetch("https://app.vivasmartcare.com/api/v04t-query-fall-sensitivity", {
						method: "POST",
						body: JSON.stringify({ deviceId: deviceID }),
						headers: { "Content-Type": "application/json" },
					});
					// Cihazın yanıt verip DB'yi güncellemesi için 3 saniye bekle ve veriyi tekrar çek
					setTimeout(() => {
						fetchData();
					}, 3000);
				} catch (err) {
					console.error("Otomatik hassasiyet sorgu hatası:", err);
				}
			};
			querySensitivity();
		}
	}, [id, brand === "V04T" || brand === "Vivistar"]);

	useEffect(() => {
		const selectedOrg = orgName?.find(
			(org) => org.organisationName === organization
		);
		setOrg(selectedOrg);
		setFloorCount(parseInt(selectedOrg?.organisationFloors));
		setBasement(parseInt(selectedOrg?.organisationBasements));
		setRoomCount(parseInt(selectedOrg?.organisationRooms));
	}, [organization]);

	if (loading) {
		return (
			<div className="device-detail-loading">
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Yükleniyor...</span>
				</div>
				<p>Cihaz bilgileri yükleniyor...</p>
			</div>
		);
	}

	return (
		<div className="user-detail-screen">
			<div className="device-detail-header">
				<h2>Cihaz Detayları</h2>
				<p className="device-detail-subtitle">
					Cihaz bilgilerini buradan görüntüleyebilir ve güncelleyebilirsiniz.
				</p>
			</div>

			{/* Hata ve Başarı Mesajları */}
			{error && (
				<div className="alert alert-danger" role="alert">
					{error}
				</div>
			)}
			{success && (
				<div className="alert alert-success" role="alert">
					{success}
				</div>
			)}

			<div className="device-info-wrapper">
				<div className="info">
					<span>Cihaz ID:</span>
					<Form.Control
						type="text"
						value={deviceID}
						onChange={(e) => setDeviceID(e.target.value)}
					/>
				</div>
				<div className="info">
					<span>Kurum Adı:</span>
					<Form.Select onChange={(e) => setOrganization(e.target.value)}>
						{orgName?.map((org, index) => (
							<option
								value={org.organisationName}
								key={index}
								selected={org.organisationName === organization && "true"}
							>
								{org.organisationName}
							</option>
						))}
					</Form.Select>
				</div>
				<div className="info">
					<span>Cihaz Markası</span>
					<Form.Select value={brand} onChange={(e) => setBrand(e.target.value)}>
						<option value="Vayyar">Düşme Cihazı</option>
						<option value="Viva02P">Viva02P</option>
						<option value="Viva03D">Viva03D</option>
						<option value="Vivistar">V04T</option>
					</Form.Select>
				</div>
				<div className="info">
					<span>Kullanıcı Adı:</span>
					<Form.Select onChange={(e) => setPerson(e.target.value)}>
						{usernames?.map((username, index) => (
							<option
								value={username.userName}
								key={index}
								selected={username.userName === person && "true"}
							>
								{username.userName}
							</option>
						))}
					</Form.Select>
				</div>
				<div className="info">
					<span>Cihaz Durumu:</span>
					<Form.Select
						value={status}
						onChange={(e) => setStatus(e.target.value)}
					>
						{deviceStatus.map((dStatu, index) => (
							<option
								value={dStatu}
								key={index}
								selected={status === dStatu && "true"}
							>
								{dStatu}
							</option>
						))}
					</Form.Select>
				</div>
				<div className="info">
					<span>Satın Alma Tarihi</span>
					<Form.Control
						type="text"
						value={purchaseDate}
						onChange={(e) => setPurchaseDate(e.target.value)}
					/>
				</div>
				<div className="info">
					<span>Kurulum Tarihi:</span>
					<Form.Control
						type="text"
						value={installationDate}
						onChange={(e) => setInstallationDate(e.target.value)}
					/>
				</div>
				<div className="info">
					<span>Konum:</span>
					<Form.Select onChange={(e) => setLocation(e.target.value)}>
						{locations.map((loc, index) => (
							<option
								value={loc}
								key={index}
								selected={location === loc ? "true" : "false"}
							>
								{loc}
							</option>
						))}
					</Form.Select>
				</div>
				{location === "Kurum" && (
					<div className="info">
						<span>Süit Bilgisi:</span>
						<Form.Control
							type="text"
							placeholder="Süit Bilgisi"
							value={suiteName}
							onChange={(e) => setSuiteName(e.target.value)}
						/>
					</div>
				)}
				<div className="info">
					<span>Bulunduğu Kat:</span>
					<Form.Select
						required
						value={floor}
						onChange={(e) => setFloor(e.target.value)}
					>
						<option>Kat Seçiniz:</option>

						{floorCount > 0 && (
							<>
								{typeof basement === "number" && basement < 0
									? Array.from(
										{ length: floorCount - basement + 1 },
										(_, index) => basement + index
									).map((currentFloor) => (
										<option
											key={currentFloor}
											value={currentFloor}
											selected={floor == currentFloor}
										>
											{currentFloor === 0
												? "Zemin Kat"
												: `${currentFloor}. Kat`}
										</option>
									))
									: Array.from(
										{ length: floorCount },
										(_, index) => index + 1
									).map((currentFloor) => (
										<option
											key={currentFloor}
											value={currentFloor}
											selected={floor == currentFloor}
										>
											{currentFloor}. Kat
										</option>
									))}
							</>
						)}
					</Form.Select>
				</div>

				{location === "Kurum" || location === "Ev" ? (
					<div className="info">
						<span>Oda Tipi</span>
						<Form.Select
							required
							value={roomType}
							onChange={(e) => setRoomType(e.target.value)}
						>
							{roomTypeSelect.map((room, index) => (
								<option value={room} key={index} selected={room === roomType}>
									{room}
								</option>
							))}
						</Form.Select>
					</div>
				) : (
					<div className="info">
						<span>Bulunduğu Oda:</span>
						<Form.Select
							required
							value={room}
							onChange={(e) => setRoom(e.target.value)}
						>
							<option>Oda Seçiniz:</option>
							{roomCount &&
								roomCount > 0 &&
								[...Array(roomCount).keys()].map((roomCount, index) => (
									<option
										key={index + 1}
										value={index + 1}
										selected={room == index + 1}
									>
										{index + 1}. Oda
									</option>
								))}
						</Form.Select>
					</div>
				)}
				<div className="info">
					<span>Oda İsmi:</span>
					<Form.Control
						type="text"
						required
						value={roomName}
						onChange={(e) => setRoomName(e.target.value)}
					/>
				</div>
				<div className="info phone-numbers-section">
					<span>Bildirim Alan Numara:</span>
					{smsPhone.map((phoneNumber, index) => (
						<div key={index} className="phone-number-row">
							<InputMask
								mask="+90__________"
								replacement={{ _: /\d/ }}
								value={phoneNumber}
								showMask
								onChange={(e) => handlePhoneNumberChange(index, e.target.value)}
								className="phone-input"
							/>
							{smsPhone.length < 6 && index === smsPhone.length - 1 && (
								<Button
									variant="primary"
									onClick={addPhoneNumber}
									className="btn-add-phone"
								>
									Ekle
								</Button>
							)}
							{index > 0 && (
								<Button
									variant="danger"
									onClick={() => removePhoneNumber(index)}
									className="btn-remove-phone"
								>
									Çıkart
								</Button>
							)}
						</div>
					))}
				</div>
				{(brand === "V04T" || brand === "Vivistar") && (
					<div className="info sos-number-section">
						<span>SOS Numarası (V04T):</span>
						<div className="sos-numbers-grid">
							{Array.isArray(sosNumber) && sosNumber.map((num, index) => (
								<div key={index} className="sos-number-item">
									<small className="text-muted">SOS {index + 1}</small>
									<InputMask
										mask="+90__________"
										replacement={{ _: /\d/ }}
										value={num}
										showMask
										onChange={(e) => {
											const newSos = [...sosNumber];
											newSos[index] = e.target.value;
											setSosNumber(newSos);
										}}
										className="sos-input"
										placeholder="+90XXXXXXXXXX"
									/>
								</div>
							))}
							<Button
								variant="success"
								onClick={async () => {
									// En az bir numara dolu olmalı
									if (sosNumber.every(num => !num.replace(/\D/g, ""))) {
										setError("En az bir SOS numarası girilmelidir.");
										return;
									}

									try {
										setUpdatingSos(true);
										setError("");
										setSuccess("");

										const response = await fetch(
											"https://app.vivasmartcare.com/api/v04t-update-sos",
											{
												method: "POST",
												body: JSON.stringify({
													deviceId: deviceID,
													sosNumber: sosNumber,
												}),
												headers: { "Content-Type": "application/json" },
											}
										);

										const data = await response.json();

										if (response.ok) {
											setSuccess(
												data.message || "SOS numaraları başarıyla güncellendi."
											);
											setTimeout(() => {
												fetchData();
											}, 1000);
										} else {
											setError(
												data.error ||
												"SOS numaraları güncellenirken bir hata oluştu"
											);
										}
									} catch (error) {
										console.error("SOS numaraları güncelleme hatası:", error);
										setError("Bağlantı hatası. Lütfen tekrar deneyin.");
									} finally {
										setUpdatingSos(false);
									}
								}}
								disabled={updatingSos}
								className="btn-update-sos"
							>
								{updatingSos ? (
									<>
										<span
											className="spinner-border spinner-border-sm me-2"
											role="status"
											aria-hidden="true"
										></span>
										Güncelleniyor...
									</>
								) : (
									"SOS Numaralarını Güncelle"
								)}
							</Button>
						</div>
						<small className="text-muted">
							V04T cihazları için 4 adede kadar SOS numarası tanımlayabilirsiniz.
						</small>
					</div>
				)}
				{(brand === "V04T" || brand === "Vivistar") && (
					<div className="info fall-sensitivity-section">
						<span>Düşme Hassasiyeti (V04T):</span>
						<div className="fall-sensitivity-wrapper">
							<div className="fall-sensitivity-slider-container">
								<input
									type="range"
									min="1"
									max="6"
									value={fallSensitivity}
									onChange={(e) => setFallSensitivity(parseInt(e.target.value))}
									className="fall-sensitivity-slider"
								/>
								<div className="fall-sensitivity-labels">
									<span className="sensitivity-label">1</span>
									<span className="sensitivity-label">2</span>
									<span className="sensitivity-label">3</span>
									<span className="sensitivity-label">4</span>
									<span className="sensitivity-label">5</span>
									<span className="sensitivity-label">6</span>
								</div>
							</div>
							<div className="fall-sensitivity-value">
								<span className="sensitivity-current">{fallSensitivity}</span>
								<span className="sensitivity-desc">
									{fallSensitivity <= 2 ? "Düşük Hassasiyet" :
										fallSensitivity <= 4 ? "Orta Hassasiyet" :
											"Yüksek Hassasiyet"}
								</span>
							</div>
							<div className="fall-sensitivity-btns">
								<Button
									variant="success"
									onClick={async () => {
										try {
											setUpdatingFallSensitivity(true);
											setError("");
											setSuccess("");

											const response = await fetch(
												"https://app.vivasmartcare.com/api/v04t-update-fall-sensitivity",
												{
													method: "POST",
													body: JSON.stringify({
														deviceId: deviceID,
														fallSensitivity: fallSensitivity,
													}),
													headers: { "Content-Type": "application/json" },
												}
											);

											const data = await response.json();

											if (response.ok) {
												setSuccess(
													data.message || "Düşme hassasiyeti başarıyla güncellendi."
												);
												setTimeout(() => {
													fetchData();
												}, 1000);
											} else {
												setError(
													data.error ||
													"Düşme hassasiyeti güncellenirken bir hata oluştu"
												);
											}
										} catch (error) {
											console.error("Düşme hassasiyeti güncelleme hatası:", error);
											setError("Bağlantı hatası. Lütfen tekrar deneyin.");
										} finally {
											setUpdatingFallSensitivity(false);
										}
									}}
									disabled={updatingFallSensitivity}
									className="btn-update-fall-sensitivity"
								>
									{updatingFallSensitivity ? (
										<>
											<span
												className="spinner-border spinner-border-sm me-2"
												role="status"
												aria-hidden="true"
											></span>
											Güncelleniyor...
										</>
									) : (
										"Hassasiyeti Güncelle"
									)}
								</Button>
							</div>
						</div>
						<small className="text-muted">
							Düşme algılama hassasiyetini ayarlayın. 1 = En düşük (sadece güçlü düşmeleri algılar), 6 = En yüksek (hafif düşmeleri de algılar)
						</small>
					</div>
				)}
				<div className="info device-note">
					<span>Cihaz Notları:</span>
					<Form.Control
						type="text"
						required
						value={deviceNote}
						onChange={(e) => setDeviceNote(e.target.value)}
					/>
				</div>
				<div className="button-wrapper">
					<Button
						variant="primary"
						onClick={updateDevice}
						disabled={updating}
						className="btn-save"
					>
						{updating ? (
							<>
								<span
									className="spinner-border spinner-border-sm me-2"
									role="status"
									aria-hidden="true"
								></span>
								Güncelleniyor...
							</>
						) : (
							"Kaydet - Güncelle"
						)}
					</Button>
					{/* <Button
            variant="danger"
            onClick={() => {
              const userConfirmed = window.confirm(
                "Cihaz kalıcı olarak silinecektir. Emin misiniz?"
              );

              if (userConfirmed) {
                deleteDevice();
              }
            }}
          >
            Cihazı Sil
          </Button> */}
				</div>
			</div>
		</div>
	);
};

export default DeviceDetailScreen;
